<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>

                    <div class="orderListTable">

                        <div class="tableTool">
                            <div class="toolRight">
                                <el-button type="primary" size="small" @click="toDialog('add')"><i
                                    class="el-icon-circle-plus-outline"></i>添加
                                </el-button>
                                <el-button type="primary" size="small" @click="toDialog('edit')">编辑
                                </el-button>
                                <el-button type="primary" size="small" @click="deleteOne">删除
                                </el-button>
                            </div>
                        </div>

                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%" class="tableContent">
                            <el-table-column
                                prop="taskNum"
                                label="时尚饰品模型数"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="taskMoney"
                                label="时尚饰品奖励金额"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="taskPeople"
                                align="center"
                                header-align="center"
                                label="时尚饰品参与人数">
                            </el-table-column>

                            <el-table-column
                                prop="toyNum"
                                label="微缩景观模型数"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="toyMoney"
                                label="微缩景观奖励金额"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="toyPeople"
                                align="center"
                                header-align="center"
                                label="微缩景观参与人数">
                            </el-table-column>

                            <el-table-column
                                prop="lifeNum"
                                label="电子产品模型数"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="lifeMoney"
                                label="电子产品奖励金额"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="lifePeople"
                                align="center"
                                header-align="center"
                                label="电子产品参与人数">
                            </el-table-column>
                        </el-table>

<!--                        <el-pagination-->
<!--                            background-->
<!--                            @current-change="handleCurrentChange"-->
<!--                            @prev-click="handleCurrentChange"-->
<!--                            @next-click="handleCurrentChange"-->
<!--                            layout="total,prev, pager, next,jumper"-->
<!--                            :current-page="current"-->
<!--                            :page-size="pageSize"-->
<!--                            :total="total" class="pagination">-->
<!--                        </el-pagination>-->
                    </div>
                </div>
            </div>
        </div>

        <!--查看-->
        <match_dialog ref="matchDetailsDialogRef"></match_dialog>

        <!-- 获奖 -->

    </div>
</template>

<script>
import {activitiesMatchList, deleteActivityMatch} from "../../utils/interface";
// import match_dialog from './activeDialog/matchDialog'
// match_dialog: () => import(match_dialog)

export default {
    components: {
        match_dialog:()=>import('./activeDialog/matchDialog')
    },
    data() {
        return {
            dialogFormVisible:false,
            tableData:[],
            infoData:[],

            current: 1,
            pageSize: 10,
            total: 0,

            uuid:'',
            taskNum:'',
            taskMoney:'',
            taskPeople:'',

            toyNum:'',
            toyMoney:'',
            toyPeople:'',

            lifeNum:'',
            lifeMoney:'',
            lifePeople:'',

        }
    },
    computed: {
        contentViewHeight() {
            let height = document.documentElement.clientHeight - 120
            return {minHeight: height + 'px'}
        },
    },
    created() {
        this.getList();
        /*this.activityUuid = this.$route.params.uuid;
        if(this.activityUuid!=undefined){
            this.chooseActivityWayInfo();
        }

        getActivityInfo({activityStatus:"PREPARE,COLLECT,EVALUATE,FINISHED"}).then((res)=>{
            this.activityList = res;
        });*/
    },
    methods: {

        getList(){

            let params = {
                current:this.current,
                pageSize:this.pageSize,
            };
            activitiesMatchList(params).then((res)=>{
                this.total = res.total;
                this.tableData = res.list;
                if (res.list.length>0){
                    this.uuid = res.list[0].uuid;
                    this.infoData = res.list[0];
                }

            });
        },
        resetData(){
            this.account = "";
            this.createDate = [];
            this.teamName = '';
            this.worksName = '';
            this.code = '';
            this.activityUuid = "";
            this.activityWayUuid = "";
            this.orderBy = '';
            this.startTime = "";
            this.endTime = "";
            this.scoreStatus = "";
            this.search();
        },

        // 分页
        handleCurrentChange(val){
            this.current = val;
            this.getList();
        },
        search(){
            this.current = 1;
            this.getList();
        },

        toDialog(type){
            this.$refs.matchDetailsDialogRef.init(type,this.infoData);
        },
        deleteOne(){
            this.$confirm('确定要移除当前数据嘛？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                console.log(this.uuid);
                deleteActivityMatch(this.uuid).then((res) => {
                    if (res.success) {
                        this.$message.success("删除成功");
                        this.getList();
                    }
                });
            });
        }
    }
}
</script>

<style scoped lang="less">
.orderManagementClass {
    position: relative;
    width: 100%;
    padding: 0 20px 20px;
    .orderManagementContent {
        background: #fff;
        .printOrderListBox {
            padding: 20px;
            .orderSearchBox {
                display: flex;
                flex-wrap: wrap;
                margin-bottom: 20px;

                /deep/ .el-input {
                    width: initial;
                    // margin-bottom: 22px;
                    margin-right: 30px;
                }

                /deep/ .el-input__inner {
                    width: 242px;
                    height: 35px;
                    min-height: 35px;
                    font-size: 12px;
                    color: #999999;
                    background-color: #f2f4f7;
                    border: 1px solid #f2f4f7;
                    border-radius: 5px;

                    &:hover,
                    &:focus {
                        background-color: #fff;
                        border: 1px solid #108ee9;
                    }
                }

                /deep/ .el-input__prefix {
                    top: -3px;
                }

                /deep/ .el-input__suffix {
                    top: 2px;
                }

                /deep/ .el-button {
                    display: block;
                    line-height: 35px;
                    padding: 0;
                    height: 35px;
                }

                .searchBtn {
                    width: 82px;
                    background: #3d7fff;
                    border: none;
                    border-radius: 15px;
                    font-size: 14px;
                    color: #ffffff;
                }

                .resetBtn {
                    color: #333333;
                }
                .searchItem {
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;
                    .name {
                        padding-right: 20px;
                        min-width: 100px;
                    }
                }
                .searchItem_time {
                    margin-right: 30px;
                    /deep/.el-input__inner {
                        width: 292px;
                    }
                }
            }

            .tableContent {
                min-height: 650px;

                /deep/ .el-table__header {
                    tr {
                        th {
                            border-right: none;
                        }
                    }

                    /deep/ .el-table__cell {
                        padding: 5px 0;
                        background: #f2f5fc;
                    }
                }

                /deep/ .el-table__body {
                    img {
                        vertical-align: middle;
                        width: 52px;
                        height: 50px;
                    }
                }
            }

            .pagination {
                margin-top: 20px;
                text-align: right;
            }
            .orderListTable {
                margin-top: 35px;
            }
        }
    }
    .tableTool {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 20px;
        .toolRight {
            button {
                width: 83px;
                height: 30px;
                background: rgba(21, 126, 251, 1);
                border: none;
                border-radius: 15px;
                font-size: 13px;
                color: #fff;

                i {
                    padding-right: 5px;
                }

                &:hover {
                    background: #61a2f0;
                }
            }
        }
    }
    .dialogBox{
        .details{
            .detailsItem{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .itemContent{
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    padding: 0 30px;
                    .one-row{
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        .label{
                            padding-right: 15px;
                            min-width: 95px;
                        }
                        .name{
                            color: #000;
                        }
                    }
                    .two-row{
                        width: 100%;
                        margin-bottom: 22px;
                        display: flex;
                        .label{
                            padding-right: 15px;
                            min-width: 95px;
                        }
                        .name{
                            color: #000;
                        }
                    }
                }
                .itemPictureContent{
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    padding: 0 30px;
                    justify-content: space-between;
                    .one-row{
                        width: 30%;
                        margin-bottom: 22px;
                        img{
                            width: 100%;
                            height: 138px;
                            border: 1px solid #ddd;
                        }
                        .name{
                            text-align: center;
                            padding-top: 10px;
                            font-size: 14px;
                            display: flex;
                            .label{
                                min-width: 80px;
                            }
                        }
                    }
                }
            }
        }
        .audit{
            padding-bottom: 20px;
            h3{
                font-weight: 700;
                font-size: 16px;
                color: #000;
                margin-top: 0;
                letter-spacing: 1px;
                border-bottom: 1px solid #ddd;
                padding-bottom: 15px;
            }
            .auditContent{
                padding: 0 30px;
            }
            .cause{
                display: flex;
                margin-top: 20px;
                .causeTitle{
                    min-width: 80px;
                    color: #3a8ee6;
                }
                .causeContent{
                    color: #000;
                }
            }
            .auditEnter{
                text-align: center;
                padding-top: 20px;
                button{
                    width: 120px;
                }
            }
        }
    }
}
.sorting {
    p {
        margin: 0;
    }
    /deep/.el-radio-button--small .el-radio-button__inner {
        display: flex;
        align-items: center;
    }
    /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
        background-color: #3d7fff;
    }
}
.flex {
    display: flex;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/activityMatchList.vue